import React, { useRef, FC } from 'react'

export default function memoWithRefs<PropsType extends Record<string, unknown> = Record<string, never>>(
  Component: FC<PropsType>,
  refPropNames: string[] = [],
  name?: string
) {
  const refPropNamesSet = new Set(refPropNames)
  const MemoizedComponent = React.memo<PropsType>(Component, (prevProps, nextProps) => {
    const nextPropsNames = Object.keys(nextProps)
    for (const propName of nextPropsNames) {
      if ('propsRef' !== propName && !refPropNamesSet.has(propName) && prevProps[propName] !== nextProps[propName]) {
        return false
      }
    }
    return true
  })
  const MemoizedComponentWrapper = (props: PropsType) => {
    const propsRef = useRef<Pick<PropsType, (typeof refPropNames)[number]>>()
    if (null == propsRef.current) {
      propsRef.current = {}
    }
    for (const propName of refPropNames) {
      propsRef.current[propName] = props[propName] as PropsType[typeof propName]
    }
    return <MemoizedComponent {...props} propsRef={propsRef} />
  }
  if (name) {
    MemoizedComponentWrapper.displayName = name
  }
  return MemoizedComponentWrapper
}
